var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FEF6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 17.0026H28.6663V14.6693C28.6663 13.3743 27.628 12.3359 26.333 12.3359H21.6663C20.3713 12.3359 19.333 13.3743 19.333 14.6693V17.0026H14.6663C13.3713 17.0026 12.3447 18.0409 12.3447 19.3359L12.333 32.1693C12.333 33.4643 13.3713 34.5026 14.6663 34.5026H33.333C34.628 34.5026 35.6663 33.4643 35.6663 32.1693V19.3359C35.6663 18.0409 34.628 17.0026 33.333 17.0026ZM26.333 17.0026H21.6663V14.6693H26.333V17.0026Z",
    fill: "#AF7702"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDefault);
export default __webpack_public_path__ + "static/media/jobDefault.0f4a4b386a9d2a43fee0390a55ac1847.svg";
export { ForwardRef as ReactComponent };